/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { identifyUser } from 'Services/analytics';

export default function useAnalyticsIdentify(viewer) {
  useEffect(() => {
    if (viewer) {
      identifyUser(viewer);
    }
  }, [viewer]);
}
